import Loadable from '../../components/loadable';

const GymProfileKiosk = Loadable({
  loader: () => import('../../pages/account_profile/gym_profile_kiosk'),
});

angular.module('gym').value('GymProfileKiosk', GymProfileKiosk);
